module.exports = __webpack_public_path__ + "assets/1fa5793687f14e931676e3c6624ce5aa.json";